import React, { useState } from 'react';
import './GameBoard.css';
import DiceSvg from './DiceSvg';
import { playMeowHappy, playPurrContent } from '../utils/audioUtils';

const GameBoard = ({ dice, held, rollsLeft, onRoll, onToggleHold, isMobile, onShowMobileMenu }) => {
  const [isRolling, setIsRolling] = useState(false);
  const [transformedDice, setTransformedDice] = useState([]);
  
  // Cat transformation images
  const catTransformations = [
    '/cat-images/cat-fly-1.png',
    '/cat-images/cat-fly-2.webp', 
    '/cat-images/cat-fly-3.png',
    '/cat-images/cat-surprise.png',
    '/cat-images/cat-high-5.png'
  ];
  
  const handleDiceClick = (index) => {
    if (rollsLeft < 3 && dice[index] !== null) {
      // Play happy meow when clicking dice
      playMeowHappy();
      onToggleHold(index);
    } else if (dice[index] === null) {
      // Play content purr when clicking empty dice (sleeping cats)
      playPurrContent();
    }
  };

  const handleRoll = () => {
    setIsRolling(true);
    // Random transformations during roll
    const newTransformations = dice.map(() => 
      catTransformations[Math.floor(Math.random() * catTransformations.length)]
    );
    setTransformedDice(newTransformations);
    
    // Quick shake effect for rolling
    document.body.classList.add('screen-shake', 'roll-chaos');
    
    // Single smaller explosion
    const explosionDiv = document.createElement('div');
    explosionDiv.className = 'roll-explosion';
    explosionDiv.innerHTML = Array.from({ length: 20 }, (_, i) => 
      `<img src="${catTransformations[i % catTransformations.length]}" class="explosion-cat explosion-${i % 10}" style="--random-x: ${Math.random()}; --random-y: ${Math.random()};" alt="Exploding cat" />`
    ).join('');
    document.body.appendChild(explosionDiv);
    
    // Clean up after short duration
    setTimeout(() => {
      if (explosionDiv.parentNode) {
        explosionDiv.parentNode.removeChild(explosionDiv);
      }
    }, 1000);
    
    // Call the actual roll function
    onRoll();
    
    // Reset effects after quick duration
    setTimeout(() => {
      setIsRolling(false);
      setTransformedDice([]);
      document.body.classList.remove('screen-shake', 'roll-chaos');
    }, 500);
  };

  return (
    <div className="dice-area">
      <div className="dice-container">
        {dice.map((die, index) => (
          <div 
            key={index}
            className={`die ${held[index] ? 'held' : ''} ${rollsLeft < 3 && die !== null ? 'clickable' : ''} ${die === null ? 'empty' : ''} ${isRolling && !held[index] ? 'rolling rainbow-trail' : ''}`}
            onClick={() => handleDiceClick(index)}
          >
            {isRolling && !held[index] && transformedDice[index] ? (
              <img 
                src={transformedDice[index]} 
                alt="Flying cat" 
                className="cat-transformation"
              />
            ) : die === null ? (
              <img 
                src="/cat-images/cat-laydown.png" 
                alt="Sleeping cat" 
                className="empty-cat"
              />
            ) : (
              <DiceSvg value={die} type="classic" />
            )}
          </div>
        ))}
      </div>

      <div className="roll-button-container">
        <button 
          className="roll-button"
          onClick={handleRoll}
          disabled={rollsLeft === 0}
        >
          {rollsLeft > 0 ? (
            <>
              Roll {'🎲'.repeat(rollsLeft)}
            </>
          ) : (
            'Score dice'
          )}
        </button>
        {isMobile && (
          <button 
            className="mobile-menu-btn-gameboard"
            onClick={onShowMobileMenu}
            title="Game options"
          >
            ☰
          </button>
        )}
      </div>
    </div>
  );
};

export default GameBoard;